import _ from 'lodash';
import * as moment from 'moment-timezone';

import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormArray, FormControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Action, select, Store } from '@ngrx/store';
import { concatMap, debounceTime, filter, map, take, takeUntil, throttleTime } from 'rxjs/operators';
import {
  selectEventPageCampaignList,
  selectCampaignList,
  selectDonationCampaignList, selectLiveAuctionCampaignList,
  selectSilentAuctionCampaignList
} from 'app/campaign/features/campaign.selectors';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { ImageService } from 'app/core/services/image.service';
import { HybridEventSchema } from '../../schemas/hybrid-event';
import { fromEvent, of, Subject } from 'rxjs';
import { SlideSchema, SponsorSchema } from 'app/virtual-event/structure/virtual-event';
import {
  addEventPageBlock,
  clearSelectedEvent,
  createHEvent, createHEventSuccess, createStream, createStreamSuccess,
  loadEventListAndSelect,
  // loadEventConfig,
  putHEvent,
  selectEvent,
  updateEventConfigPage, updateEventPageBlock
} from '../../features/event.actions';
import { selectEventSelected } from '../../features/event.selectors';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { loadEventCampaignList } from 'app/campaign/features/campaign.actions';
import { VirtualEventTypeService } from '../../services/virtual-event-type.service';
import { StreamProviderService } from '../../services/stream-provider.service';
import { PledgeBehaviourService } from '../../services/pledge-behaviour.service';
import { TimeZoneService } from '../../services/time-zone.service';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { ToastService } from 'app/toast/services/toast.service';
import {
  ConfigurationSchema, DonationCampaignPartSchema,
  EventConfigSchema,
  FaqPartSchema, LiveAuctionCampaignPartSchema, SilentAuctionCampaignPartSchema,
  SlidesPartSchema,
  TextPartSchema, VideoContainerPartSchema, ImagePartSchema,
} from '../../schemas/virtual-event';
import { EventPageBlockTypeService } from '../../services/event-page-block-type.service';
import { ArrayValidators } from '../../validators/array.validators';
import { Actions, ofType } from '@ngrx/effects';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs/tabs.component';
import { CookieService } from 'ngx-cookie-service';
import * as DialogActions from '../../../dialog/features/dialog.actions';
import { StreamInfoStructure } from '../../models/stream-model';
import { VideoProviderService } from '../../services/video-provider.service';
import { MdbTabsComponent } from 'mdb-angular-ui-kit/tabs';
import { EventTabsService } from '../../services/event-tabs.service';
import { Router } from '@angular/router';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';

@Component({
  selector: 'app-hybrid-event',
  templateUrl: './hybrid-event.component.html',
  styleUrls: ['./hybrid-event.component.scss']
})
export class HybridEventComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('tabs')
  set tabs(tabs: MdbTabsComponent) {
    this.tabsService.tabs = tabs;
  };
  get tabs(): MdbTabsComponent {
    return this.tabsService.tabs;
  }

  @Input()
  public id: string = null;

  public event: any = null;

  public step: number = 0;
  public disableTypeSelect = false;
  public user: any;

  public selectedEvent = this.store.pipe(select(selectEventSelected));
  public ticketingCampaigns$ = this.store.pipe(
    select(selectCampaignList),
    map(list => {
      return this.getTicketingCampaignList(list);
    })
  );
  public campaigns$: any = this.store.pipe(
    select(selectEventPageCampaignList),
    map(list => {
      return _.filter(list, { status: 0 });
    })
  );

  public donationCampaigns$: any = this.store.pipe(
    select(selectDonationCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  public form: UntypedFormGroup = new UntypedFormGroup({});
  public inPersonEvent: UntypedFormGroup = null;
  public virtualEvent: UntypedFormGroup = null;

  public virtualEventSlide: UntypedFormGroup = new UntypedFormGroup({});
  public slideMode: string = 'list';
  public slideSubmitted: boolean = false;

  public virtualEventSponsor: UntypedFormGroup = new UntypedFormGroup({});
  public sponsorMode: string = 'list';
  public sponsorSubmitted: boolean = false;
  public saveAndExit: boolean = false;
  public currentSponsorIndex = null;

  public submitted = false;

  public accordion = {
    eventPaddles: { expanded: false },
    tableAssignment: { expanded: false },
    golfPack: { expanded: false },
    ticketing: { expanded: false },
    coverFee: { expanded: false },

    info: { expanded: false },
    stream: { expanded: false },
    settings: { expanded: false },
    music: { expanded: false }
  }

  public takeUntilSubject: Subject<any> = new Subject();

  public videoProviderSelected: number = 0;
  public videoContainerPart: UntypedFormGroup = null;
  public eventPageSlide: UntypedFormGroup = null;
  public eventConfiguration: UntypedFormGroup = null;

  // Event page parts
  public removeFromNav: FormGroup = null;
  public textPart: FormGroup = null;
  public faqPart: FormGroup = null;
  public slidesPart: FormGroup = null;
  public slidesPartBulkImport: FormControl = null;
  public imagesQueue: any[] = [];
  public config: FormGroup = null;
  public eventConfigData: any = null;

  public donationCampaignPart: UntypedFormGroup = null;
  public silentAuctionCampaignPart: UntypedFormGroup = null;
  public liveAuctionCampaignPart: UntypedFormGroup = null;
  public imagePart: UntypedFormGroup = null;
  public eventImageSelected: boolean = false;

  public configMode: string = 'list';
  public eventPageSlideMode: string = 'list';
  public EPSlideSubmitted: boolean = false;
  public selectedPageType = 1;
  public eventPageId!: string;
  public selectedProvider: number;
  public paybeeStreamInfo: StreamInfoStructure;
  public themeConfigurationScreen: boolean = false;

  public silentAuctions$: any = this.store.pipe(
    select(selectSilentAuctionCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  public liveAuctions$: any = this.store.pipe(
    select(selectLiveAuctionCampaignList),
    map(list => {
      return _.filter(list, {status: 0});
    })
  );

  prevStep: number;
  prevTab: number = 0;
  setActiveTab: any;

  constructor(
    public router: Router,
    public store: Store,
    public fb: UntypedFormBuilder,
    public sharedService: SharedService,
    public campaignService: CampaignService,
    public imageService: ImageService,
    public virtualEventTypeService: VirtualEventTypeService,
    public streamProviderService: StreamProviderService,
    public pledgeBehaviourService: PledgeBehaviourService,
    public eventPageBlockTypeService: EventPageBlockTypeService,
    public timeZoneService: TimeZoneService,
    public domSanitizer: DomSanitizer,
    public toastService: ToastService,
    public element: ElementRef,
    public updates$: Actions,
    private ngZone: NgZone,
    private cookieService: CookieService,
    public videoProviderService: VideoProviderService,
    public tabsService: EventTabsService,
    public cdr: ChangeDetectorRef,
    private chooseImageModalService: ChooseImageModalService,
  ) {
    this.tabsService.lastStep = 5;
  }

  ngOnInit(): void {
    let localOrgData = window['localOrgData'];
    this.user = localOrgData.user;

    const { sharedService } = this;

    this.campaignService.generateForm(this.form, HybridEventSchema);
    this.inPersonEvent = this.form.get('inPersonEvent') as UntypedFormGroup;
    this.virtualEvent = this.form.get('virtualEvent') as UntypedFormGroup;

    this.campaignService.generateForm(this.virtualEventSlide, SlideSchema);
    this.campaignService.generateForm(this.virtualEventSponsor, SponsorSchema);

    this.eventPageSlide = this.fb.group({});
    this.eventConfiguration = this.fb.group({});

    this.removeFromNav = this.fb.group({});
    this.config = this.fb.group({});
    this.textPart = this.fb.group({});
    this.faqPart = this.fb.group({
      options: new UntypedFormArray([], ArrayValidators.minLength(1))
    });

    this.slidesPart = this.fb.group({
      slides: new FormArray([], ArrayValidators.minLength(1)),
    });

    this.slidesPartBulkImport = new FormControl([]);

    this.donationCampaignPart = this.fb.group({});
    this.silentAuctionCampaignPart = this.fb.group({});
    this.liveAuctionCampaignPart = this.fb.group({});
    this.videoContainerPart = this.fb.group({});
    this.imagePart = this.fb.group({});

    this.campaignService.generateForm(this.eventPageSlide, SlideSchema);
    this.campaignService.generateForm(this.eventConfiguration, EventConfigSchema);

    this.campaignService.generateForm(this.config, ConfigurationSchema);
    this.campaignService.generateForm(this.textPart, TextPartSchema);
    this.campaignService.generateForm(this.faqPart, FaqPartSchema);
    this.campaignService.generateForm(this.slidesPart, SlidesPartSchema);
    this.campaignService.generateForm(this.videoContainerPart, VideoContainerPartSchema);
    this.campaignService.generateForm(this.imagePart, ImagePartSchema);

    this.campaignService.generateForm(this.donationCampaignPart, DonationCampaignPartSchema);
    this.campaignService.generateForm(this.silentAuctionCampaignPart, SilentAuctionCampaignPartSchema);
    this.campaignService.generateForm(this.liveAuctionCampaignPart, LiveAuctionCampaignPartSchema);

    this.eventConfiguration.controls.eventPageBlockType.setValue(4)

    if (this.id) {
      this.store.dispatch({
        type: loadEventListAndSelect.type,
        payload: this.id
      });
      //this.eventPageId = this.payload.hybridEventInfo.eventPageId;
    }

    this.store.dispatch({
      type: loadEventCampaignList.type,
      payload: sharedService.token
    });

    const timestamp = this.virtualEvent.get('startDateTimeGmtUnix').value * 1000;
    this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000: timestamp);

    this.selectedEvent.pipe(
      filter(event => {
        const id = _.get(event, 'hybridEventInfo.id', null);
        return !_.isNull(id)
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((event) => {
      this.event = event;
      this.eventPageId = event.hybridEventInfo.eventPageId;
    });

    this.selectedEvent.pipe(
      filter(event => {
        const id = _.get(event, 'hybridEventInfo.id', null);
        return !_.isNull(id)
      }),
      map(event => {
        return event.hybridEventInfo;
      }),
      takeUntil(this.takeUntilSubject)
    ).subscribe((event: any) => {
      this.resetEvent(this.form);
      this.campaignService.initializeForm(this.form, event, HybridEventSchema);

      if (event) {
        this.selectedProvider = event.virtualEvent.streamProvider;

        if (event.virtualEvent.payBeeStreamingInfo) {
          this.paybeeStreamInfo = event.virtualEvent.payBeeStreamingInfo;
        }
      }

      const timestamp = this.virtualEvent.get('startDateTimeGmtUnix').value * 1000;
      this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000: timestamp);
    });

    const timeZoneData = this.virtualEvent.get('timeZoneData');
    timeZoneData.get('name').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const zone = moment.tz.zone(value);
      const abbrControl = timeZoneData.get('abbr');

      const timestamp = this.virtualEvent.get('startDateTimeGmtUnix').value * 1000;
      const abbr = zone.abbr(timestamp);

      abbrControl.setValue(abbr);
    });

    timeZoneData.get('abbr').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(abbr => {
			const abbrControl = timeZoneData.get('abbr');
      const nameControl = timeZoneData.get('name');
      const offsetControl = timeZoneData.get('offset');

      const zone = moment.tz.zone(nameControl.value);

      const index = _.findIndex(zone.abbrs, value => _.isEqual(value, abbr));
      const offset = zone.offsets[index] * -60;

			offsetControl.setValue(offset);

      const matches = abbr.match(/[\+\-][0-9]+/);
      const abbrValue = _.isArray(matches) ? `GMT ${matches[0]}`: abbr;

      this.virtualEvent.get('timeZoneAbbr').setValue(abbrValue);
      this.virtualEvent.get('timeZone').setValue(offset);

      abbrControl.setValue(abbrValue, { emitEvent: false });
    });

    this.virtualEvent.get('startDateTimeGmtUnix').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      filter(() => {
        const nameControl = timeZoneData.get('name');
        return !_.isNull(nameControl.value)
      }),
      filter(() => {
        const abbrControl = timeZoneData.get('abbr');
        return !_.isNull(abbrControl.value)
      }),
      map(value => value * 1000),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const nameControl = timeZoneData.get('name');
      const abbrControl = timeZoneData.get('abbr');
      const zone = moment.tz.zone(nameControl.value);
      const abbr = zone.abbr(value);
      abbrControl.setValue(abbr);

      const timestamp = this.virtualEvent.get('startDateTimeGmtUnix').value * 1000;
      this.timeZoneService.updateTimeZoneList(timestamp === 0 ? moment().unix() * 1000: timestamp);
    });

    this.inPersonEvent.get('imageFile').valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const windowURL = window.URL || window.webkitURL;
      const url = windowURL.createObjectURL(value);
      this.imageService.cropper({
        url: this.domSanitizer.bypassSecurityTrustUrl(url),
        id: 'in-person-event-image',
        name: value.name,
        type: value.type,
      });
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'in-person-event-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.inPersonEvent.get('imageDataUrl').setValue(result);
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'in-person-event-image'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if(result === false) {
        this.resetInPersonImage();
      } else {
        this.inPersonEvent.get('image').setValue(result.imageUrl);
      }
    });

    this.imageService.initializeImageControl('hybrid-event-image', this.form, this.takeUntilSubject);
    this.imageService.initializeImageControl('virtual-event-image', this.virtualEvent, this.takeUntilSubject);
    this.imageService.initializeImageControl('virtual-event-slide-image', this.virtualEventSlide, this.takeUntilSubject);
    this.imageService.initializeImageControl('virtual-event-sponsor-image', this.virtualEventSponsor, this.takeUntilSubject);
    this.imageService.initializeImageControl('event-page-slide-image', this.eventPageSlide, this.takeUntilSubject);
    this.imageService.initializeImageControl('hybrid-event-page-image', this.imagePart, this.takeUntilSubject);

    this.inPersonEvent.get('paddleRequired').valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const paddleMinNum = this.inPersonEvent.get('paddleMinNum');
      const emptyPaddleCount = this.inPersonEvent.get('emptyPaddleCount');

      const paddleMinNumValidators = [Validators.required, Validators.min(0)];

      paddleMinNum.clearValidators();
      paddleMinNum.setValidators(paddleMinNumValidators);
      paddleMinNum.setValue(0);
      paddleMinNum.updateValueAndValidity({ emitEvent: false });

      emptyPaddleCount.clearValidators();
      emptyPaddleCount.setValidators([Validators.required])
      emptyPaddleCount.setValue(0);
      emptyPaddleCount.updateValueAndValidity({ emitEvent: false });
    });

    this.inPersonEvent.get('paddleRequired').valueChanges.pipe(
      filter(value => value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const paddleMinNum = this.inPersonEvent.get('paddleMinNum');
      const emptyPaddleCount = this.inPersonEvent.get('emptyPaddleCount');

      const paddleMinNumValidators = [Validators.required, Validators.min(1)];

      paddleMinNum.clearValidators();
      paddleMinNum.setValidators(paddleMinNumValidators)
      paddleMinNum.updateValueAndValidity({ emitEvent: true });

      emptyPaddleCount.clearValidators();
      emptyPaddleCount.setValidators([Validators.required])
      emptyPaddleCount.updateValueAndValidity({ emitEvent: true });
    });


    this.inPersonEvent.get('paddleMinNum').valueChanges.pipe(
      map(value => {
        const paddleRequired = this.inPersonEvent.get('paddleRequired');
        const defaultValue = paddleRequired.value ? 1: 0;
        return value < 1 ? defaultValue: value;
      }),
      takeUntil(this.takeUntilSubject)
    );

    this.campaignService.configGroup(this.virtualEvent, this.virtualEvent, 'additionalInfoRequired', [
      { name: 'additionalInfoName', defaultValue: "", validators: [Validators.required] },
    ], this.takeUntilSubject);

    this.campaignService.configGroup(this.virtualEvent, this.virtualEvent, 'defaultDonateCampaignRequired', [
      { name: 'defaultDonateCampaignId', defaultValue: "", validators: [Validators.required] },
    ], this.takeUntilSubject);


    this.updates$.pipe(
      ofType(
        createStreamSuccess.type,
      ),
      takeUntil(this.takeUntilSubject)
    )
      .subscribe((action: { type: string, data: StreamInfoStructure }) => {
        this.paybeeStreamInfo = action.data;
        this.store.dispatch({
          type: selectEvent.type,
          payload: this.event
        });
      });

    this.updates$.pipe(
      ofType(
        createHEventSuccess.type
      ),
      takeUntil(this.takeUntilSubject)
    )
      .subscribe((action: {data: any, type: string}) => {
        if (action.data &&  !this.saveAndExit) {
          if (!this.event) {
            this.event = {};
            this.event.hybridEventInfo = action.data;
          }
          this.id = action.data.id;
          this.eventPageId = action.data.eventPageId;
          this.campaignService.initializeForm(this.form, action.data, HybridEventSchema);
        }

        this.saveAndExit = false;
      });

    this.slidesPartBulkImport.valueChanges.pipe(
      filter(value => !_.isNull(value)),
      takeUntil(this.takeUntilSubject)
    ).subscribe(value => {
      const id = 'slide-images';
      if (value && value.length) {
        this.imagesQueue = value;
        this.uploadImages(id);

      } else {
        const windowURL = window.URL || window.webkitURL;
        const url = windowURL.createObjectURL(value);
        this.imageService.cropper({
          url: this.domSanitizer.bypassSecurityTrustUrl(url),
          id,
          name: value.name,
          type: value.type,
        });
      }
    });

    this.imageService.imageDataUrlSubject.pipe(
      filter(({ id }) => id === 'slide-images'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      this.cdr.markForCheck();
    });

    this.imageService.imageSubject.pipe(
      filter(({ id }) => id === 'slide-images'),
      takeUntil(this.takeUntilSubject)
    ).subscribe(({ result }) => {
      if (result === false) {
        console.log(result, false);
      } else {
        if (result.imageUrl) {
          const form = new FormGroup({});
          this.campaignService.generateForm(form, SlideSchema);
          this.campaignService.initializeForm(form, {
            imageUrl: result.imageUrl,
            name: ""
          }, SlideSchema);
          const slides = this.slidesPart.get('slides') as FormArray;
          slides.push(form);
        }
      }

      this.cdr.markForCheck();
    });
  }

  ngAfterViewInit() {
    this.virtualEvent.get('lobbyMusic').valueChanges.pipe(
      filter(value => !_.isNull(value) && !_.isEmpty(value)),
      throttleTime(1000),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const lobbyMusicAudio = window['$']('#lobbyMusicAudio');
      if(lobbyMusicAudio.length > 0) {
        lobbyMusicAudio[0].load();
      }
    });

    this.virtualEvent.get('endMusic').valueChanges.pipe(
      filter(value => !_.isNull(value) && !_.isEmpty(value)),
      throttleTime(1000),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const endMusicAudio = window['$']('#endMusicAudio');
      if(endMusicAudio.length > 0) {
        endMusicAudio[0].load();
      }
    });
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    this.tabsService.reset();
    this.resetFormBlocks();
    this.saveAndExit = false;

    this.store.dispatch({
      type: clearSelectedEvent.type
    });
  }

  onTabChange(event: MdbTabChange): void {
    const currentTab = event.index;
    let isFormValid = true;

    this.onStepChange(currentTab);

    if (this.prevTab === currentTab) {
      return;
    }

    if (this.prevTab < currentTab && currentTab > 0) {
      switch (this.prevTab) {
        case 0: {
          if (this.onValidHybridEvent()) {
          } else {
            this.onInvalidTab(0)
            isFormValid = this.onValidate()
            return;
          }
          break;
        }
        case 1: {
          if (this.onValidInPersonEvent()) {
          } else {
            this.onInvalidTab(1)
            isFormValid = this.onValidate()
            return;
          }
          break;
        }
        case 2: {
          if (this.onValidVirtualEvent()) {
          } else {
            this.onInvalidTab(2)
            isFormValid = this.onValidate()
            return;
          }
          break;
        }

      }
      switch (currentTab) {
        case 3: {
          if (this.onValidate()) {
          } else {
            this.onInvalidTab(this.prevTab)
            isFormValid = this.onValidate();
          }

          break
        }
        case 4: {
          if (this.onValidate()) {
          } else {
            this.onInvalidTab(this.prevTab)
            isFormValid = this.onValidate();
          }

          break;
        }
        case 5: {
          if (this.onValidate()) {
          } else {
            this.onInvalidTab(this.prevTab)
            isFormValid = this.onValidate();
          }

          break;
        }
      }
    }

    this.tabsService.onTabChange(event, isFormValid);
  }

  onValidHybridEvent(){
     const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent','virtualEvent']);
    if(valid){
      return true
    }
    return false
  }
  
  onValidInPersonEvent(){
    const valid = this.campaignService.isFormValid(this.form, ['virtualEvent','hybridEvent']);
    if(valid){
      return true
    }
    return false

  }
  
  onValidVirtualEvent(){
    const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent','hybridEvent']);
    if(valid){
      return true
    }
    return false
  }

  moveToEventPageList(mode) {
    this.configMode = mode;
    return;
  }

  onInvalidTab(tabIndex){
    this.tabs.setActiveTab(tabIndex)
  }

  onStepChange(currentTab){

    this.prevTab = this.step
    this.step = currentTab
  }

  onCancel(): void {
    this.router.navigateByUrl('/event/list');
  }

  onSave() {
    const valid = this.campaignService.isFormValid(this.form, []);
    if (valid) {
      this.saveAndExit = true;

      const requestObject = this.campaignService.generateRequestObject(this.form, HybridEventSchema);
      return this.store.dispatch({
        type: this.id ? putHEvent.type : createHEvent.type,
        payload: requestObject,
        redirect: true
      });
    }

    if(this.step === 0) {
      const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent', 'virtualEvent']);
      if(valid) {
        this.step++;
        this.onSave();
      } else {
        return this.onValidate();
      }
    }

    if(this.step === 1) {
      const valid = this.campaignService.isFormValid(this.form, ['virtualEvent']);
      if(valid) {
        this.step++;
        this.onSave();
      } else {
        return this.onValidate();
      }
    }
    if(this.step === 2) {
      const valid = this.campaignService.isFormValid(this.form, []);
      if(valid) {
        this.step++;
        this.onSave();
      } else {
        return this.onValidate();
      }
    }else{
      setTimeout(() => {
        const firstInvalidControl: HTMLElement = this.element.nativeElement.querySelector(".ng-invalid");
        const panel = _.get(firstInvalidControl.dataset, 'panel', null);
        if(!_.isNull(panel)) {
          _.set(this.accordion, `${panel}.expanded`, true);
        }

        setTimeout(()=>{
          window.scroll({
          top: this.getTopOffset(firstInvalidControl),
          left: 0,
          behavior: "smooth"
        });
        },500)

        fromEvent(window, "scroll").pipe(
          debounceTime(100),
          take(1),
          takeUntil(this.takeUntilSubject)
        ).subscribe(() => firstInvalidControl.focus());
      }, 100);
    }
  }

  onChangeProvider(event): void {
    this.selectedProvider = event;
    if (this.event && this.event.hybridEventInfo && this.event.hybridEventInfo.virtualEvent && this.event.hybridEventInfo.virtualEvent.id) {
      if (this.selectedProvider === 4) {
        this.store.dispatch({
          type: createStream.type,
          payload: {
            virtualEventId: this.event.hybridEventInfo.virtualEvent.id,
          }
        });
      }
    }
  }

  onClickStreamInfo(): void {
    const action: Action = DialogActions.openDialog({
      payload: {
        name: 'streamHelp',
        options: {
          size: 'large',
          modalClass: 'modal--paybee modal-lg',
          containerClass: 'mdb-modal-backdrop-paybee'
        },
        initialState: {
          rtmpUrl: this.paybeeStreamInfo.rtmpUrl,
          streamName: this.paybeeStreamInfo.streamName,
          streamKey: this.paybeeStreamInfo.streamKey
        }
      }
    });
    this.store.dispatch(action);
  }

  goToHybridInfo() {
    this.step = 0;
  }

  goToInPersonInfo() {
    if(this.step < 1) {
      return this.goToStep(1);
    }

    const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent', 'virtualEvent']);
    if(valid) {
      this.step = 1;
    } else {
      this.onValidate();
    }
  }

  goToVirtualInfo() {
    if(this.step < 2) {
      return this.goToStep(2);
    }

    const valid = this.campaignService.isFormValid(this.form, ['virtualEvent']);
    if(valid) {
      this.step = 2;
    } else {
      this.onValidate();
    }
  }

  goToSlidesInfo() {
    if(this.step < 3) {
      return this.goToStep(3);
    }

    const valid = this.campaignService.isFormValid(this.form, []);
    if(valid) {
      this.step = 3;
    } else {
      this.onValidate();
    }
  }

  goToSponsorsInfo() {
    if(this.step < 4) {
      return this.goToStep(4);
    }

    const valid = this.campaignService.isFormValid(this.form, []);
    if(valid) {
      this.step = 4;
    } else {
      this.onValidate();
    }
  }

  goToStep(step) {
    if(this.step >= step) {
      return true;
    }

    if(this.step === 0) {
      const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent', 'virtualEvent']);
      if(valid) {
        this.step++;
        return this.goToStep(step);
      } else {
        return this.onValidate();
      }
    }

    if(this.step === 1) {
      const valid = this.campaignService.isFormValid(this.form, ['virtualEvent']);
      if(valid) {
        this.step++;
        return this.goToStep(step);
      } else {
        return this.onValidate();
      }
    }

    if(this.step === 2) {
      const valid = this.campaignService.isFormValid(this.form, []);
      if(valid) {
        this.step++;
        return this.goToStep(step);
      } else {
        return this.onValidate();
      }
    }

    if(this.step === 3) {
      const valid = this.campaignService.isFormValid(this.form, []);
      if(valid) {
        this.step++;
        return this.goToStep(step);
      } else {
        return this.onValidate();
      }
    }

    return true;
  }

  onManageTables() {
    const id = this.inPersonEvent.get('id');
    window['orgMain'].manageEventTable(id.value, function(value) { })
  }

  onValidate(): boolean {
    this.submitted = true;
    if(this.form.valid) {
      return true;
    }
    this.form.markAllAsTouched();
    this.tabs.setActiveTab(this.prevStep);

    setTimeout(() => {
      const firstInvalidControl: HTMLElement = this.element.nativeElement.querySelector(".ng-invalid");
      const panel = _.get(firstInvalidControl.dataset, 'panel', null);
      if(!_.isNull(panel)) {
        _.set(this.accordion, `${panel}.expanded`, true);
      }

      setTimeout(()=>{
        window.scroll({
        top: this.getTopOffset(firstInvalidControl),
        left: 0,
        behavior: "smooth"
      });
      },500)

      fromEvent(window, "scroll").pipe(
        debounceTime(100),
        take(1),
        takeUntil(this.takeUntilSubject),
      ).subscribe(() => firstInvalidControl.focus());
    }, 100);

    return false;
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  onChangeMusic(type) {
    switch(type) {
      case 'lobby':
        return window['showUploadMusicModal'](this.virtualEvent, "lobbyMusic");
      case 'end':
        return window['showUploadMusicModal'](this.virtualEvent, "endMusic");
    }
  }

  onResetMusic(type) {
    switch(type) {
      case 'lobby':
        return this.virtualEvent.get('lobbyMusic').setValue('/images/bensound-elevate.mp3');
      case 'end':
        return this.virtualEvent.get('endMusic').setValue('/images/bensound-happyrock.mp3');
    }
  }

  onChangeSponsorMode(mode) {
    this.resetEvent(this.virtualEventSponsor);
    this.campaignService.initializeForm(this.virtualEventSponsor, {}, SponsorSchema);
    this.sponsorMode = mode;
    this.sponsorSubmitted = false;
  }

  editSponsor(event) {
    const { sponsor, index } = event
    this.currentSponsorIndex = index

    this.resetEvent(this.virtualEventSponsor);
    this.campaignService.initializeForm(this.virtualEventSponsor, sponsor,  SponsorSchema);
    this.sponsorMode = 'editor';
    this.sponsorSubmitted = false;
  }

  onSaveSponsor() {
    this.sponsorSubmitted = true;
    if (this.virtualEventSponsor.invalid || this.virtualEventSponsor.controls.imageUrl.value === '/images/blank_2x1.png') {
      this.virtualEventSponsor.markAllAsTouched();
      return;
    }

    if (this.currentSponsorIndex || this.currentSponsorIndex === 0) {
      (this.virtualEvent.get('sponsors') as UntypedFormArray).at(this.currentSponsorIndex).patchValue(this.virtualEventSponsor.value);
      this.currentSponsorIndex = null;
    } else {
      const form = new UntypedFormGroup({});
      this.campaignService.generateForm(form, SponsorSchema);
      this.campaignService.initializeForm(form, this.virtualEventSponsor.value, SponsorSchema);
      const sponsors = this.virtualEvent.get('sponsors') as UntypedFormArray;
      sponsors.push(form);
    }

    this.onChangeSponsorMode('list');
  }

  onChangeSlideMode(mode) {
    this.resetEvent(this.virtualEventSlide);
    this.campaignService.initializeForm(this.virtualEventSlide, {}, SlideSchema);
    this.slideMode = mode;
    this.slideSubmitted = false;
  }

  onSaveSlide() {
    this.slideSubmitted = true;
    if(this.virtualEventSlide.invalid || this.virtualEventSlide.controls.imageUrl.value === '/images/blank_2x1.png') {
      this.virtualEventSlide.markAllAsTouched();
      return;
    }

    const form = new UntypedFormGroup({});
    this.campaignService.generateForm(form, SlideSchema);
    this.campaignService.initializeForm(form, this.virtualEventSlide.value, SlideSchema);

    const slides = this.virtualEvent.get('slides') as UntypedFormArray;
    slides.push(form);

    this.onChangeSlideMode('list');
  }

  resetEvent(formGroup) {
    _.forEach(formGroup.controls, (control, key) => {
      if(control instanceof UntypedFormGroup) {
        this.resetEvent(control);
      } else if(control instanceof UntypedFormArray) {
        while (control.length !== 0) {
          control.removeAt(0)
        }
      } else if(control instanceof UntypedFormControl) {
        switch(key) {
          case 'inviteMessage':
          case 'confirmMessage':
            control.reset('');
            break;
          default:
            control.reset();
        }
      }
    });
  }

  getTicketingCampaignList(campaigns) {
    var list = []
    campaigns.forEach(function(campaign) {
      var ticketingTypeData = campaign.campaignTypeData
      if(campaign.type == CAMPAIGN_TYPE.TICKETING
        && campaign.status == 0
        && ticketingTypeData.guestRequired
        && (ticketingTypeData.linkedEventId == undefined ||
          ticketingTypeData.linkedEventId == "" ||
          ticketingTypeData.linkedEventId == null
        )
      ) {
        list.push(campaign)
      }
    });
    return list;
  }

  openChooseImageModal(type = 0, placeOfCall = null) { // 0 for 2x1, 1 for 1x1
    const params = {
      start: 0,
      returnCount: 40,
      filterBy:[type]
    }

    this.campaignService.getOrganizationImages(params).pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((imageList: any)=> {
      const list = imageList || [];
      const images = list.filter((image) => image.type === type)
      const modalRef = this.chooseImageModalService.open({ images, type });
    
      modalRef.onClose.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe((imageUrl) =>{
        if(imageUrl) {
          switch (placeOfCall) {
            case 'inPersonEventImage':
              this.inPersonEvent.get(`imageDataUrl`).setValue(imageUrl);
              this.inPersonEvent.get(`image`).setValue(imageUrl);
              break;
            case 'virtualEventImage':
              this.virtualEvent.get(`imageDataUrl`).setValue(imageUrl);
              this.virtualEvent.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'sponsor':
              this.virtualEventSponsor.get(`imageDataUrl`).setValue(imageUrl);
              this.virtualEventSponsor.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'lobbySlides':
              this.virtualEventSlide.get(`imageDataUrl`).setValue(imageUrl);
              this.virtualEventSlide.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'eventPageSlides':
              this.eventPageSlide.get(`imageDataUrl`).setValue(imageUrl);
              this.eventPageSlide.get(`imageUrl`).setValue(imageUrl);
              break;
            case 'imageSection':
              this.imagePart.get(`imageDataUrl`).setValue(imageUrl);
              this.imagePart.get(`imageUrl`).setValue(imageUrl);
              break;
            default:
              this.form.get(`imageDataUrl`).setValue(imageUrl);
              this.form.get(`imageUrl`).setValue(imageUrl);
              break;
          }
          
          this.toastService.show('success', 'Added Successfully!', {delay: 2000});
        }
        this.chooseImageModalService.modalRef = null;
      })
    })
  }

  resetInPersonImage() {
    this.inPersonEvent.get('imageFile').setValue(null);
    this.inPersonEvent.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.inPersonEvent.get('image').setValue('/images/blank_2x1.png');
  }

  resetHybridImage() {
    this.form.get('imageFile').setValue(null);
    this.form.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.form.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  resetSlideImage() {
    this.virtualEventSlide.get('imageFile').setValue(null);
    this.virtualEventSlide.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.virtualEventSlide.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  resetEventPageSlideImage() {
    this.eventPageSlide.get('imageFile').setValue(null);
    this.eventPageSlide.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.eventPageSlide.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  resetImagePart() {
    this.imagePart.get('imageFile').setValue(null);
    this.imagePart.get('imageDataUrl').setValue('/images/blank_2x1.png');
    this.imagePart.get('imageUrl').setValue('/images/blank_2x1.png');
  }

  getSlideImageErrorMessage() {
    if(this.slideSubmitted === false) {
      return;
    }

    if (this.virtualEventSlide.get('imageUrl').value === '/images/blank_2x1.png') {
      return 'Image cannot be empty';
    }

    return '';
  }

  getSponsorImageErrorMessage() {
    if(this.sponsorSubmitted === false) {
      return;
    }

    if (this.virtualEventSponsor.get('imageUrl').value === '/images/blank_2x1.png') {
      return 'Image cannot be empty';
    }

    return '';
  }

  updateSection(data) {
    this.eventConfigData = data.payload.eventConfigData;

    if (data.payload.index || data.payload.index === 0) {
      const section = this.eventConfigData.pageBlocks[data.payload.index];

      switch (section.type) {
        case 1:
          // text
          this.textPart.reset({
            removeFromNav: section.removeFromNav,
            textBlock: section.text,
            type: 1,
            textBlockTitle: section.blockTitle,
            id: section.id
          });

          break;
        case 2:
          // FAQ
          const faqArr = this.fb.array(section.faq.map(faq => {
            return this.fb.group({
              question: new UntypedFormControl(faq.question, []),
              answer: new UntypedFormControl(faq.answer, [])
            });
          }));

          this.faqPart.reset({
            removeFromNav: section.removeFromNav,
            options:  faqArr,
            type: 2,
            faqBlockTitle: section.blockTitle,
            id: section.id
          });
          this.faqPart.setControl('options', faqArr);

          break;
        case 3:
          // slides
          const slides = this.fb.array(section.slides.map(slide => {
            return this.fb.group({
              imageUrl: new UntypedFormControl(slide.imageUrl, [Validators.required]),
              name: new UntypedFormControl(slide.name, [Validators.maxLength(512)])
            });
          }));

          this.slidesPart.reset({
            removeFromNav: section.removeFromNav,
            slides,
            type: 3,
            slidesBlockTitle: section.blockTitle,
            id: section.id
          });
          this.slidesPart.setControl('slides', slides);
          break;
        case 4:
          // donation campaign
          this.donationCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 4,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 5:
          // silent auction
          this.silentAuctionCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 5,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 6:
          // live auction
          this.liveAuctionCampaignPart.reset({
            removeFromNav: section.removeFromNav,
            campaignId: section.campaignId,
            type: 6,
            title: section.blockTitle,
            id: section.id
          });
          break;
        case 7:
          // video container
          this.videoContainerPart.reset({
            removeFromNav: section.removeFromNav,
            videoProvider: section.videoData.provider,
            videoContainerDesc: section.videoData.desc,
            type: 7,
            videoContainerTitle: section.blockTitle,
            videoContainerUrl: section.videoData.url,
            id: section.id
          });

          break;
          case 8: 
          //image
          this.imagePart.reset({
            removeFromNav: section.removeFromNav,
            iamgeDataUrl: section.imageUrl,
            imageUrl: section.imageUrl,
            imageBlockTitle: section.blockTitle,
            imageBlockText: section.text,
            type: 8,
            id: section.id
          })

          const imageUrl = this.imagePart.get('imageUrl').value === '/images/org_logo_default_v2.svg' ?
          '/images/blank_2x1.png':
          this.imagePart.get('imageUrl').value;
          this.imagePart.get('imageDataUrl').setValue(imageUrl);
          this.imagePart.get('imageUrl').setValue(imageUrl);

          if(this.imagePart.value.imageDataUrl != '/images/blank_2x1.png' && this.imagePart.value.imageUrl != '/images/blank_2x1.png') {
            this.eventImageSelected = true;
          } else {
            this.eventImageSelected = false;
            this.imagePart.markAllAsTouched();
            return
          }

          break;
      }

      this.disableTypeSelect = true;
      this.selectedPageType = section.type;
      this.eventConfiguration.controls.eventPageBlockType.setValue(section.type);
      this.configMode = data.mode;
      return;
    }
  }

  addSection(data) {
    this.disableTypeSelect = false;
    this.resetEvent(this.eventConfiguration);
    this.campaignService.initializeForm(this.eventConfiguration, {}, EventConfigSchema);
    this.configMode = data.mode;
    this.resetFormBlocks();
  }

  changeEventConfigMode(data) {
    if (data.payload.index || data.payload.index === 0) {
      this.updateSection(data);
      return;
    }
    this.addSection(data);
  }

  
  updateEventPage(payload) {
    if (this.id) {
      this.store.dispatch({
        type: updateEventConfigPage.type,
        payload
      });
    }
  }

  onSaveEventPageBlock() {
    let payload;
    let formArray;
    const form = this.fb.group({});
    
    switch (this.eventConfiguration.controls.eventPageBlockType.value) {
      case 1:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.textPart.value.removeFromNav,
            type: 1,
            blockTitle: this.textPart.value.textBlockTitle,
            text: this.textPart.value.textBlock
          }
        };

        if (this.textPart.value.id) {
          payload.eventPageBlock.id = this.textPart.value.id;
        }

        if (this.textPart.invalid) {
          this.textPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, TextPartSchema);
        this.campaignService.initializeForm(form, this.textPart.value, TextPartSchema);

        formArray = this.config.get('textPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 2:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.faqPart.value.removeFromNav,
            type: 2,
            faq: this.faqPart.value.options,
            blockTitle: this.faqPart.value.faqBlockTitle
          }
        };

        if (this.faqPart.value.id) {
          payload.eventPageBlock.id = this.faqPart.value.id;
        }

        if (this.faqPart.invalid) {
          this.faqPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, FaqPartSchema);
        this.campaignService.initializeForm(form, this.faqPart.value, FaqPartSchema);

        formArray = this.config.get('faqPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 3:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.slidesPart.value.removeFromNav,
            type: 3,
            slides: this.slidesPart.value.slides,
            blockTitle: this.slidesPart.value.slidesBlockTitle
          }
        };

        if (this.slidesPart.value.id) {
          payload.eventPageBlock.id = this.slidesPart.value.id;
        }

        if (this.slidesPart.invalid) {
          this.slidesPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, SlidesPartSchema);
        this.campaignService.initializeForm(form, this.slidesPart.value, SlidesPartSchema);

        formArray = this.config.get('slidesPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 4:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.donationCampaignPart.value.removeFromNav,
            type: 4,
            campaignId: this.donationCampaignPart.value.campaignId,
            blockTitle: this.donationCampaignPart.value.title
          }
        };

        if (this.donationCampaignPart.value.id) {
          payload.eventPageBlock.id = this.donationCampaignPart.value.id;
        }

        if (this.donationCampaignPart.invalid) {
          this.donationCampaignPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, DonationCampaignPartSchema);
        this.campaignService.initializeForm(form, this.donationCampaignPart.value, DonationCampaignPartSchema);

        formArray = this.config.get('donationCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 5:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.silentAuctionCampaignPart.value.removeFromNav,
            type: 5,
            campaignId: this.silentAuctionCampaignPart.value.campaignId,
            blockTitle: this.silentAuctionCampaignPart.value.title
          }
        };

        if (this.silentAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.silentAuctionCampaignPart.value.id;
        }

        if (this.silentAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.silentAuctionCampaignPart.value.id;
        }

        this.campaignService.generateForm(form, SilentAuctionCampaignPartSchema);
        this.campaignService.initializeForm(form, this.silentAuctionCampaignPart.value, SilentAuctionCampaignPartSchema);

        formArray = this.config.get('silentAuctionCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 6:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.liveAuctionCampaignPart.value.removeFromNav,
            type: 6,
            campaignId: this.liveAuctionCampaignPart.value.campaignId,
            blockTitle: this.liveAuctionCampaignPart.value.title
          }
        };

        if (this.liveAuctionCampaignPart.value.id) {
          payload.eventPageBlock.id = this.liveAuctionCampaignPart.value.id;
        }

        if (this.liveAuctionCampaignPart.invalid) {
          this.liveAuctionCampaignPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, LiveAuctionCampaignPartSchema);
        this.campaignService.initializeForm(form, this.liveAuctionCampaignPart.value, LiveAuctionCampaignPartSchema);

        formArray = this.config.get('liveAuctionCampaignPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 7:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            removeFromNav:this.videoContainerPart.value.removeFromNav,
            type: 7,
            blockTitle: this.videoContainerPart.value.videoContainerTitle,
            videoData: {
              desc: this.videoContainerPart.value.videoContainerDesc,
              url: this.videoContainerPart.value.videoContainerUrl,
              provider: this.videoContainerPart.value.videoProvider
            }
          }
        };

        if (this.videoContainerPart.value.id) {
          payload.eventPageBlock.id = this.videoContainerPart.value.id;
        }

        if (this.videoContainerPart.invalid) {
          this.videoContainerPart.markAllAsTouched();
          return;
        }

        this.campaignService.generateForm(form, VideoContainerPartSchema);
        this.campaignService.initializeForm(form, this.videoContainerPart.value, VideoContainerPartSchema);

        formArray = this.config.get('videoContainerPart') as UntypedFormArray;
        formArray.push(form);
        break;
      case 8:
        payload = {
          eventPageId: this.event.hybridEventInfo.eventPageId,
          eventPageBlock: {
            type: 8,
            imageUrl: this.imagePart.value.imageUrl,
            blockTitle: this.imagePart.value.imageBlockTitle,
            text: this.imagePart.value.imageBlockText,
            removeFromNav:this.imagePart.value.removeFromNav
          }
        }

        if (this.imagePart.value.id) {
          payload.eventPageBlock.id = this.imagePart.value.id;
        }

        if (this.imagePart.invalid) {
          this.imagePart.markAllAsTouched();
          return;
        }

        if(this.imagePart.value.imageDataUrl != '/images/blank_2x1.png' && this.imagePart.value.imageUrl != '/images/blank_2x1.png') {
          this.eventImageSelected = true;
        } else {
          this.eventImageSelected = false;
          this.imagePart.markAllAsTouched();
          return
        }

        this.campaignService.generateForm(form, ImagePartSchema);
        this.campaignService.initializeForm(form, this.imagePart.value, ImagePartSchema);

        formArray = this.config.get('imagePart') as UntypedFormArray;
        formArray.push(form);

        break;
    }

    const valid = this.campaignService.isFormValid(form, []);
    if (!valid) {
      form.markAllAsTouched();
      return;
    }

    if (payload.eventPageBlock.id) {
      this.store.dispatch({
        type: updateEventPageBlock.type,
        payload
      });
    } else {
      this.store.dispatch({
        type: addEventPageBlock.type,
        payload
      });
    }

    this.changeEventConfigMode({
      payload: {eventConfigData: this.eventConfigData},
      mode: 'list'
    });
  }

  resetFormBlocks() {
    this.faqPart.reset({options: new UntypedFormArray([], ArrayValidators.minLength(1)), type: 'faq', faqBlockTitle: '', removeFromNav: false});
    this.textPart.reset({textBlock: '', type: 'text', textBlockTitle: '', removeFromNav: false});
    (this.slidesPart.get('slides') as UntypedFormArray).clear()
    this.slidesPart.reset({slides: new UntypedFormArray([], ArrayValidators.minLength(1)), type: 'slides', slidesBlockTitle: '', removeFromNav: false});
    this.videoContainerPart.reset({videoContainerTitle: '', videoContainerDesc: '', videoContainerUrl: '', type: 'video', videoProvider: 0, removeFromNav: false});
    this.donationCampaignPart.reset({campaignId: '', type: 'donationCampaign', title: '', removeFromNav: false});
    this.silentAuctionCampaignPart.reset({campaignId: '', type: 'silentAuction', title: '', removeFromNav: false});
    this.liveAuctionCampaignPart.reset({campaignId: '', type: 'liveAuction', title: '', removeFromNav: false});
    
    this.imagePart.reset({ 
      imageBlockText: '', 
      type: 'eventPageBlockTypeImage', 
      imageBlockTitle: '', 
      removeFromNav: false,
      imageFile: null,
      imageDataUrl: '/images/blank_2x1.png',
      imageUrl: '/images/blank_2x1.png',
    });

    this.selectedPageType = 4;
  }

  onChangeEventPageSlideMode(mode) {
    this.resetEvent(this.eventPageSlide);
    this.campaignService.initializeForm(this.eventPageSlide, {}, SlideSchema);
    this.eventPageSlideMode = mode;
    this.configMode = mode === 'editor' ? '' : 'eventConfig';
  }

  onSaveEPSlide() {
    this.EPSlideSubmitted = true;

    if (this.eventPageSlide.invalid || this.eventPageSlide.controls.imageUrl.value === '/images/blank_2x1.png') {
      this.eventPageSlide.markAllAsTouched();
      return;
    }

    const form = this.fb.group({});
    this.campaignService.generateForm(form, SlideSchema);
    this.campaignService.initializeForm(form, this.eventPageSlide.value, SlideSchema);

    const slides = this.slidesPart.get('slides') as UntypedFormArray;
    slides.push(form);

    this.onChangeEventPageSlideMode('list');
  }

  onCheckAndSaveCampaign() {
    const valid = this.campaignService.isFormValid(this.form, []);

    if (valid) {
      const requestObject = this.campaignService.generateRequestObject(this.form, HybridEventSchema);

      return this.store.dispatch({
        type: this.id ? putHEvent.type: createHEvent.type,
        payload: requestObject,
        redirect: false
      });
    }

    if (this.step === 0) {
      const valid = this.campaignService.isFormValid(this.form, ['inPersonEvent', 'virtualEvent']);
      if (valid) {
        this.step++;
        this.onCheckAndSaveCampaign();
      } else {
        return this.onValidate();
      }
    }

    if (this.step === 1) {
      const valid = this.campaignService.isFormValid(this.form, ['virtualEvent']);
      if (valid) {
        this.step++;
        this.onCheckAndSaveCampaign();
      } else {
        return this.onValidate();
      }
    }
  }

  onCopyToClipboard(event, id, text = 'Copy'): void {
    event.preventDefault();

    const button: HTMLElement = document.getElementById(id);

    button.innerHTML = '<i class="far fa-copy mr-2"></i> Copied!';
    button.style.color = '#37373c';
    button.style.backgroundColor = '#dddddd';
    setTimeout(() => {
      this.ngZone.run(() => {
        button.innerHTML = `<i class="far fa-copy mr-2"></i> ${text}`;
        button.style.color = '#37373c';
        button.style.backgroundColor = '#fefefe';
      });
    }, 1200);
  }

  onLiveStreamPreview(event) {
    const action: Action = DialogActions.openDialog({
      payload: {
        name: 'streamPreview',
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee',
        },
        initialState: {
          playBackUrl: this.paybeeStreamInfo.playBackUrl,
        }
      }
    });
    this.store.dispatch(action);
  }

  getText(text: string): string {
    return text;
  }

  resetVideoUrl() {
    this.videoContainerPart.get('videoContainerUrl').setValue('')
    this.videoContainerPart.get('videoContainerUrl').markAsUntouched();
  }

  onShowThemeConfiguration(status: boolean): void {
    this.themeConfigurationScreen = status;
  }
  onAfterCollapse(accorItem) {
    this.accordion[accorItem].expanded = false;
  }

  onAfterExpand(accorItem) {
    this.accordion[accorItem].expanded  = true;
  }

  onClickImportXlsx() {
    const action = DialogActions.openDialog({
      payload: {
        name: "importSlide",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          callback: (result) => {
            const slides = this.slidesPart.get('slides') as FormArray;
            for(let control of result.controls) {
              slides.push(control);
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  onClickImportImages() {
    const action = DialogActions.openDialog({
      payload: {
        name: "importSlide",
        options: {
          size: 'large',
          modalClass:'modal--paybee modal-lg',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          callback: (result) => {
            const slides = this.slidesPart.get('slides') as FormArray;
            for(let control of result.controls) {
              slides.push(control);
            }
          }
        }
      }
    });
    this.store.dispatch(action);
  }

  uploadImages(id = 'slide-images') {
    if (!this.imagesQueue.length) {
      return;
    }

    return of.apply(null, this.imagesQueue).pipe(
      concatMap((image) => {
        return this.imageService.uploadImageByFileAndCrop(image['name'], image);
      })
    ).subscribe((response) => {
      if (response.imageUrl) {
        const form = new FormGroup({});
        this.campaignService.generateForm(form, SlideSchema);
        this.campaignService.initializeForm(form, {
          imageUrl: response.imageUrl,
          name: ""
        }, SlideSchema);
        const slides = this.slidesPart.get('slides') as FormArray;
        slides.push(form);
      }
    });
  }

}
